import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ChecklistStep, ChecklistStepResponse } from 'src/app/common/models/Checklist';
import { UserService } from 'src/app/common/sharedServices/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) { }

  /**
   * Controllo validità della checklist ad ogni cambiamento dei singoli step.
   * Se uno step ha vincolante == 'S', allora controllo che la data e l'esito siano valorizzati,
   * altrimenti controllo solo la data.
   * @param checklist è la checklist con già i valori modificati
   * @returns true se la checklist è globalmente valida, false altrimenti.
   */
  isChecklistValida(checklist: ChecklistStep[]): boolean {
    return checklist.every(step => {
      const dataString = step.data.toString();
      const dataZeroString = "0000-00-00";
      if (step.vincolante.toUpperCase() === 'S') {
        //Se vincolante, lo stato deve essere "Eseguito" o "Anomalia"
        return (step.stato === '1' || step.stato === '2') && step.data !== undefined && dataString != dataZeroString
      } else {
        return step.data !== undefined && dataString != dataZeroString;
      }
    });
  }

  async getChecklistFromServer(idAttivita: number, idEvento: number): Promise<ChecklistStep[]> {
    const userData = await this.userService.getDatiUtente();
    const completeUrl = `${userData.server}/immto_wsr_checklist_get`;

    const body = {
      aziCdazi: userData.aziCdazi,
      token: userData.token,
      operatore: userData.putSigla,
      idAttivita: idAttivita,
      idEvento: idEvento
    }
    
    const response = await lastValueFrom(this.http.post<ChecklistStepResponse>(completeUrl,body))
    return response && response.st == 0 ? response.SDTwsrChecklist : [];
  }

  async updateChecklistToServer(checklist: ChecklistStep[], idEvento: number, codiceOperatore: string): Promise<any> {
    const userData = await this.userService.getDatiUtente();
    const completeUrl = `${userData.server}/immto_wsr_checklist_upd`;
    const body = {
      'aziCdazi': userData.aziCdazi,
      'token': userData.token,
      'operatore': codiceOperatore, //operatore scelto per l'attività
      'idEvento': idEvento,
      'SDTwsrChecklistJson': JSON.stringify(checklist)
    }

    try{
      const response = await lastValueFrom(this.http.post<number>(completeUrl,body))
      if (response && response['st'] == 0)
        return true 
      else 
        throw new Error('Aggiornamento checklist evento NON andato a buon fine');
    } catch (error) {
      console.error(`Impossibile caricare la checklist per l'evento ${idEvento} su server. Da sincronizzare`, error);
      throw Error(`Impossibile caricare la checklist per l'evento ${idEvento} su server. Da sincronizzare`);
    }
  }
}
